import React from "react";
import { Grid, Card, Page, Button } from "tabler-react";
import "tabler-react/dist/Tabler.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import SiteWrapperSuperAdmin from "../SiteWrapper.superadmin.react";
import authActions from "../../redux/auth/action";
import clientService from "../../services/client";
import DownloadPopup from "./downloadPopup";
import "../../c3jscustom.css";
import "c3/c3.css";
import "react-datepicker/dist/react-datepicker.css";
import {
  AnalyticsStatsCards,
  TrafficAnalysisChart,
  ChatWithAgentChart,
  ServiceBreakdownChart,
  ReportLogsChart,
  AgentStatsChart,
  AverageHandleTimeChart,
  IdleAndOccupancyChart,
  TimeToAnswerChart,
  ChatNonWorkingHoursChart,
  QueueDropsChart,
} from "./charts";

class Analytic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dashboardData: {},
      allContextData: [],
      openDownloadPopup: false,
    };
    this.closeDownloadPopup = this.closeDownloadPopup.bind(this);
  }

  componentDidMount() {
    document.title = "Voiceoc | Analytics";

    clientService
      .getContext()
      .then((res) => {
        this.setState({
          allContextData: [...res.data.config.contexts],
        });
      })
      .catch((err) => console.error(err));

    clientService
      .getCountData()
      .then((res) => {
        this.setState({ dashboardData: res.data.data });
      })
      .catch((err) => console.error(err));
  }

  closeDownloadPopup() {
    this.setState({
      openDownloadPopup: {
        open: false,
        data: false,
      },
    });
  }

  openDownloadPopup() {
    this.setState({
      openDownloadPopup: {
        open: true,
        data: true,
      },
    });
  }

  render() {
    const { dashboardData, allContextData } = this.state;
    const aiChatTime =
      this.props.user &&
      this.props.user.settingData &&
      this.props.user.settingData.aiChatTime
        ? this.props.user.settingData.aiChatTime
        : {};

    return (
      <SiteWrapperSuperAdmin>
        <Page.Content>
          <div className="row">
            <Card.Title className="col col-6 col-sm-6 col-lg-10">
              Analytics
            </Card.Title>
            <div className="Download-btn1 pull-right col col-6 col-sm-6 col-lg-2 text-right">
              <Button
                color="primary btn"
                className="aligncentre"
                type="button"
                onClick={() => this.openDownloadPopup()}
              >
                Download
              </Button>
            </div>
          </div>

          <div className="clearfix" />

          <Grid.Row>
            <Grid.Col>
              <AnalyticsStatsCards dashboardData={dashboardData} />
            </Grid.Col>
          </Grid.Row>

          <Grid.Row>
            <TrafficAnalysisChart contexts={allContextData} />
            <ChatWithAgentChart />
            <ServiceBreakdownChart />
            <ReportLogsChart />
            <AgentStatsChart contexts={allContextData} />
            <AverageHandleTimeChart />
            <IdleAndOccupancyChart />
            <TimeToAnswerChart />
            <ChatNonWorkingHoursChart
              shiftStartTime={aiChatTime.startTime}
              shiftEndTime={aiChatTime.endTime}
            />
            <QueueDropsChart />
          </Grid.Row>

          <DownloadPopup
            openInfoPopup={this.state.openDownloadPopup}
            onChange={this.closeDownloadPopup}
          />
        </Page.Content>
      </SiteWrapperSuperAdmin>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    activeBot: state.auth.activeBot,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    logOut: () => {
      dispatch(authActions.authLogout());
    },
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Analytic),
);
